<template>
  <div>
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="active">工程师子账号申请编辑</span>
    </div>
    <div class="page">
      <div class="title">
        <h2>工程师子账号申请</h2>
        <div>
          <el-button size="small" @click="onSave()" :loading="loading">保存</el-button>
          <el-button type="primary" size="small" @click="onSave(true)" :loading="loading">保存并提交</el-button>
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <el-form :model="dataForm" :inline="true" :rules="dataRule" ref="form" label-width="180px">
          <el-form-item class="w-half" label="工程师姓名：" prop="ssoSupplierUserName">
            <el-input class="form-width" v-model="dataForm.ssoSupplierUserName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="w-half" label="开始工作年月：" prop="workBeginDate">
            <el-date-picker class="form-width" v-model="dataForm.workBeginDate" type="month" placeholder="选择年月"
              value-format="yyyy-MM" format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="w-half" label="行业经验年数：" prop="industryExperienceYear">
            <el-input-number class="form-width" v-model="dataForm.industryExperienceYear" controls-position="right"
              :max="100"></el-input-number>
          </el-form-item>

          <el-form-item class="w-half" label="工程师性别" prop="gender">
            <el-select v-model="dataForm.gender" placeholder="请选择">
              <el-option :label="'男'" value="0"></el-option>
              <el-option :label="'女'" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="w-half" label="工程师手机号：" prop="phone">
            <el-input class="form-width" v-model="dataForm.phone" placeholder="请输入">
              <el-tooltip slot="suffix" effect="dark"
                content="未注册手机号将自动注册宁东工业超市平台账号，被申请者阅读并同意《宁东工业超市服务协议》《用户隐私权政策》" placement="top">
                <el-button size="small" :disabled="!!this.timeNum" type="primary" @click="onStartTimeDown()">{{
                  this.timeNum ? `${this.timeNum}秒后重试` : "获取验证码"
                  }}</el-button>
              </el-tooltip>
            </el-input>
          </el-form-item>
          <el-form-item class="w-half" label="验证码：" prop="messageCode">
            <el-input class="form-width" v-model="dataForm.messageCode" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="申请备注：" prop="remark">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="dataForm.remark" style="width: 882px">
            </el-input>
          </el-form-item>
          <el-form-item class="w-half" label="简历：" prop="resumeFileList">
            <Upload @success="(val) => addFile(val, 1)" size="small" />

            <div v-for="(item, index) in this.dataForm.resumeFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 1)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="劳动合同证明：" prop="laborContractFileList">
            <Upload @success="(val) => addFile(val, 2)" size="small" />

            <div v-for="(item, index) in this.dataForm.laborContractFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 2)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="身份证复印件：" prop="idCardFileList">
            <Upload @success="(val) => addFile(val, 3)" size="small" />

            <div v-for="(item, index) in this.dataForm.idCardFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 3)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="保密及安全协议：" prop="securityAgreementsFileList">
            <Upload @success="(val) => addFile(val, 4)" size="small" />

            <div v-for="(item, index) in this.dataForm.securityAgreementsFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 4)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="半年以上社保缴纳证明：" prop="socialSecurityFileList">
            <Upload @success="(val) => addFile(val, 5)" size="small" />

            <div v-for="(item, index) in this.dataForm.socialSecurityFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 5)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="体检证明：" prop="physicalFileList">
            <Upload @success="(val) => addFile(val, 6)" size="small" />

            <div v-for="(item, index) in this.dataForm.physicalFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 6)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="意外险证明：" prop="insuranceFileList">
            <Upload @success="(val) => addFile(val, 7)" size="small" />

            <div v-for="(item, index) in this.dataForm.insuranceFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 7)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
          <el-form-item label="培训记录表：" prop="trainingRecordFileList">
            <Upload @success="(val) => addFile(val, 8)" size="small" />

            <div v-for="(item, index) in this.dataForm.trainingRecordFileList" :key="item.aliOssId">
              <el-tag class="fileTag" closable @close="onRemoveFile(index, 8)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '../component/upload.vue'
// 倒计时本地储存
const EcologyAccountEditTimeNum = 'ecology-account-edit-timeNum'

export default {
  components: {
    Upload
  },
  data () {
    return {
      loading: false,
      dataForm: {
        ssoSupplierUserName: '',
        workBeginDate: '',
        industryExperienceYear: '',
        gender: '',
        phone: '',
        messageCode: '',
        requestId: '',
        remark: '',
        resumeFileList: [],
        laborContractFileList: [],
        idCardFileList: [],
        securityAgreementsFileList: [],
        socialSecurityFileList: [],
        physicalFileList: [],
        insuranceFileList: [],
        trainingRecordFileList: []
      },
      dataRule: {
        ssoSupplierUserName: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        workBeginDate: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        industryExperienceYear: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        gender: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        messageCode: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        resumeFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        laborContractFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        idCardFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        securityAgreementsFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        socialSecurityFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        physicalFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        insuranceFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ],
        trainingRecordFileList: [
          { required: true, message: '此项不能为空', trigger: 'blur' }
        ]
      },
      timer: null,
      timeNum: 0
    }
  },
  created () {
    this.getTimeNum()
    this.id = this.$route.query.id
    if (this.id) {
      this.getDataSource()
    }
  },
  methods: {
    onSave (submit = false) {
      console.log('onSave')

      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单验证成功')

          const {
            resumeFileList,
            laborContractFileList,
            idCardFileList,
            securityAgreementsFileList,
            socialSecurityFileList,
            physicalFileList,
            insuranceFileList,
            trainingRecordFileList,
            ...other
          } = this.dataForm
          const param = {
            ...other,
            resumeFileList: this.formatFileList(resumeFileList),
            laborContractFileList: this.formatFileList(laborContractFileList),
            idCardFileList: this.formatFileList(idCardFileList),
            securityAgreementsFileList: this.formatFileList(
              securityAgreementsFileList
            ),
            socialSecurityFileList: this.formatFileList(socialSecurityFileList),
            physicalFileList: this.formatFileList(physicalFileList),
            insuranceFileList: this.formatFileList(insuranceFileList),
            trainingRecordFileList: this.formatFileList(trainingRecordFileList),
            // 是否直接提交
            submit
          }
          console.log(param)
          if (this.id) {
            param.id = this.id
          }
          this.loading = true
          this.$http
            .post(`/front/oms/supplier/UserApply/applyEngineerUser`, param)
            .then(({ data: res }) => {
              const { code, data } = res
              if (code === 0) {
                this.$message.success('提交成功')
                this.$router.push({
                  name: 'ecologicalServices-account-detail',
                  query: {
                    id: data
                  }
                })
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          console.log('表单验证失败')
        }
      })
    },
    getDataSource () {
      this.$http
        .get(`/front/oms/supplier/UserApply/engineerUserDetail/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res
          console.log(data)

          if (code === 0) {
            this.dataForm = data
            this.dataForm.gender = data.gender + ''
            this.dataForm.resumeFileList = []
            this.dataForm.laborContractFileList = []
            this.dataForm.idCardFileList = []
            this.dataForm.securityAgreementsFileList = []
            this.dataForm.socialSecurityFileList = []
            this.dataForm.physicalFileList = []
            this.dataForm.insuranceFileList = []
            this.dataForm.trainingRecordFileList = [];
            (data.supplierUserApplyFiles || []).forEach((item) => {
              const { businessType } = item
              switch (+businessType) {
                case 7:
                  this.dataForm.resumeFileList.push(item)
                  break
                case 8:
                  this.dataForm.laborContractFileList.push(item)
                  break
                case 9:
                  this.dataForm.idCardFileList.push(item)
                  break
                case 10:
                  this.dataForm.securityAgreementsFileList.push(item)
                  break
                case 11:
                  this.dataForm.socialSecurityFileList.push(item)
                  break
                case 12:
                  this.dataForm.physicalFileList.push(item)
                  break
                case 13:
                  this.dataForm.insuranceFileList.push(item)
                  break
                case 14:
                  this.dataForm.trainingRecordFileList.push(item)
                  break
              }
            })
          }
        })
    },
    formatFileList (fileList) {
      return fileList.map((i) => {
        return {
          ossId: i.aliOssId || i.ossId,
          fileSize: i.fileSize,
          fileName: i.fileName,
          url: i.url
        }
      })
    },
    addFile (file, type) {
      switch (type) {
        case 1:
          this.dataForm.resumeFileList.push(file)
          break
        case 2:
          this.dataForm.laborContractFileList.push(file)
          break
        case 3:
          this.dataForm.idCardFileList.push(file)
          break
        case 4:
          this.dataForm.securityAgreementsFileList.push(file)
          break
        case 5:
          this.dataForm.socialSecurityFileList.push(file)
          break
        case 6:
          this.dataForm.physicalFileList.push(file)
          break
        case 7:
          this.dataForm.insuranceFileList.push(file)
          break
        case 8:
          this.dataForm.trainingRecordFileList.push(file)
          break
      }
    },
    onRemoveFile (index, type) {
      switch (type) {
        case 1:
          this.dataForm.resumeFileList.splice(index, 1)
          break
        case 2:
          this.dataForm.laborContractFileList.splice(index, 1)
          break
        case 3:
          this.dataForm.idCardFileList.splice(index, 1)
          break
        case 4:
          this.dataForm.securityAgreementsFileList.splice(index, 1)
          break
        case 5:
          this.dataForm.socialSecurityFileList.splice(index, 1)
          break
        case 6:
          this.dataForm.physicalFileList.splice(index, 1)
          break
        case 7:
          this.dataForm.insuranceFileList.splice(index, 1)
          break
        case 8:
          this.dataForm.trainingRecordFileList.splice(index, 1)
          break
      }
    },
    getTimeNum () {
      const str = localStorage.getItem(EcologyAccountEditTimeNum)
      if (+str) {
        this.timeNum = +str
        this.sendCode()
      }
    },
    onStartTimeDown () {
      if (!this.dataForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      this.$http
        .get(
          `/front/consumer/sendVerificationCode?mobile=${this.dataForm.phone}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm.requestId = res.data.requestId
            this.$message.success('发送成功')
            this.timeNum = 60
            this.sendCode()
          }
        })
    },
    sendCode () {
      if (this.timer) {
        return
      }

      this.timer = setInterval(() => {
        this.timeNum--
        localStorage.setItem(EcologyAccountEditTimeNum, this.timeNum)
        if (this.timeNum <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    toEcology () {
      this.$router.push({ name: 'ecologicalServices' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  padding: 20px;
  min-height: 800px;

  ::v-deep .el-select {
    width: 300px;
  }
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.mr-20 {
  margin-right: 20px;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
}

.el-button--primary.is-disabled {
  opacity: 0.7;
}

.el-button--primary:hover {
  opacity: 0.9;
}

.flex {
  display: flex;
}

.fileTag {
  margin-bottom: 16px;
  color: #2a54d1;
  background-color: #f1f5fb;

  ::v-deep a {
    color: #2a54d1;
  }
}

.w-half {
  width: calc(50% - 10px);
}

.form-width {
  width: 300px;
}
</style>
